<div ng-controller="SettingsController as settingsCtrl">
    <c-auto-form config="settingsCtrl.autoFormConfig"></c-auto-form>
</div>